import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
export function TransformationSection() {
  return <section id="transformacion" className="bg-white py-12 sm:py-16" data-id="element-215" data-mp="31uw5grvc94zh">
      <div className="mx-auto max-w-4xl px-5" data-id="element-216" data-mp="2ww2r6x8899y9">
        <h2 className="mx-auto max-w-[24ch] text-center font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-217" data-mp="2rysztc1a2o7s">
          No te falta información. <span className="text-gold" data-id="element-218" data-mp="2j5pgwo7v5j5r">Te falta un orden para empezar.</span>
        </h2>

        <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-219" data-mp="2e6webqu47ckd">
          <div className="rounded-2xl bg-cream p-5" data-id="element-220" data-mp="2e7fkkaaekcik">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-221" data-mp="298l2xbo68u01">
              Hoy
            </p>
            <ul className="mt-3.5 space-y-2.5" data-id="element-222" data-mp="248gnzq2ww7bx">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] leading-snug text-taupe" data-id="element-223" data-mp="207woifuv8rmm">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-224" data-mp="f9rhvd2oaxpp" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-gold bg-white p-5 shadow-[0_20px_44px_-30px_rgba(232,62,115,0.8)]" data-id="element-225" data-mp="5epqeakxdjjy">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-226" data-mp="y1ka359x4ewd">
              Con Postres que Venden™
            </p>
            <ul className="mt-3.5 space-y-2.5" data-id="element-227" data-mp="13050ye3a5m85">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] font-semibold leading-snug text-charcoal" data-id="element-228" data-mp="p0camjvo180p">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-229" data-mp="39q1p2vsgirsv" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-center font-display text-[0.7rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-230" data-mp="1k8o3zrma3bnf">
          Elegir · Organizar · Producir · Presentar · Vender
        </p>
      </div>
    </section>;
}